var _g, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 127,
    viewBox: "0 0 119 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#invoice_filled_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.927 20a4 4 0 00-4 4v41.647a1 1 0 001.293.956l8.613-2.642a1 1 0 01.613.009l8.633 2.913a1 1 0 00.689-.018l7.218-2.866a1 1 0 01.675-.023l8.103 2.604a1 1 0 001.306-.952V24a4 4 0 00-4-4H44.927z",
    fill: "#005FF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.953,
    y: 35,
    width: 21.081,
    height: 2,
    rx: 1,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.953,
    y: 40,
    width: 18.07,
    height: 2,
    rx: 1,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.953,
    y: 45,
    width: 12.046,
    height: 2,
    rx: 1,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "invoice_filled_svg__filter0_d",
    x: 0.927,
    y: 0,
    width: 117.143,
    height: 126.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE5IiBoZWlnaHQ9IjEyNyIgdmlld0JveD0iMCAwIDExOSAxMjciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2QpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NC45MjY4IDIwQzQyLjcxNzYgMjAgNDAuOTI2OCAyMS43OTA5IDQwLjkyNjggMjRWNjUuNjQ3MkM0MC45MjY4IDY2LjMxOTcgNDEuNTc3MSA2Ni44MDA1IDQyLjIyIDY2LjYwMzNMNTAuODMzMiA2My45NjExQzUxLjAzMzQgNjMuODk5NyA1MS4yNDc4IDYzLjkwMjcgNTEuNDQ2MiA2My45Njk2TDYwLjA3OTEgNjYuODgyN0M2MC4zMDM2IDY2Ljk1ODQgNjAuNTQ3NiA2Ni45NTIgNjAuNzY3OCA2Ni44NjQ2TDY3Ljk4NjIgNjMuOTk5QzY4LjIwMTggNjMuOTEzNSA2OC40NDAzIDYzLjkwNTUgNjguNjYxMSA2My45NzY0TDc2Ljc2MzcgNjYuNTgwM0M3Ny40MDkyIDY2Ljc4NzggNzguMDY5NiA2Ni4zMDYzIDc4LjA2OTYgNjUuNjI4M1YyNEM3OC4wNjk2IDIxLjc5MDkgNzYuMjc4NyAyMCA3NC4wNjk2IDIwSDQ0LjkyNjhaIiBmaWxsPSIjMDA1RkY5Ii8+CjwvZz4KPHJlY3QgeD0iNDcuOTUzMSIgeT0iMzUiIHdpZHRoPSIyMS4wODExIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSI0Ny45NTMxIiB5PSI0MCIgd2lkdGg9IjE4LjA2OTUiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjQ3Ljk1MzEiIHk9IjQ1IiB3aWR0aD0iMTIuMDQ2MyIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0id2hpdGUiLz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZCIgeD0iMC45MjY3NTgiIHk9IjAiIHdpZHRoPSIxMTcuMTQzIiBoZWlnaHQ9IjEyNi45MzUiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiLz4KPGZlT2Zmc2V0IGR5PSIyMCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyMCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMC4yMjc0NTEgMCAwIDAgMCAwLjU5NjA3OCAwIDAgMCAwLjI4IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgInvoiceFilled as ReactComponent };